module.exports = __webpack_public_path__ + "static/img/cjx01.ef13303.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx01.png
// module id = 159
// module chunks = 0